function isLeadTimeArrayValid(leadTimeArray) {
  if (leadTimeArray && Array.isArray(leadTimeArray) && leadTimeArray.length > 0) {
    return leadTimeArray.every(
      // eslint-disable-next-line camelcase
      ({ lead_time, max_qty }) => lead_time >= 0 && max_qty >= 0
    );
  }

  return false;
}

function sortLeadTimeArray(leadTimeArray) {
  return leadTimeArray.sort((a, b) => a.lead_time - b.lead_time);
}

function calculateAvailabilityAndLeadTime(
  leadTimeArray,
  inventoryQuantity,
  inventoryPolicy = 'continue',
  quantityRequested = 1,
  useUp = false
) {
  let availabilityStatus = 'stock';
  let maxQuantityAvailable = inventoryQuantity;
  let leadTime = 0;
  let previousBucketMaxQuantity = inventoryQuantity;

  let sortedLeadTimeArray;
  let inventoryOffset = 0;

  if (isLeadTimeArrayValid(leadTimeArray) && useUp === false) {
    sortedLeadTimeArray = sortLeadTimeArray(leadTimeArray);

    // Calculate inventory offset
    if (sortedLeadTimeArray[0].lead_time === 0) {
      inventoryOffset = inventoryQuantity - Math.floor(sortedLeadTimeArray[0].max_qty);
    } else {
      inventoryOffset = inventoryQuantity;
    }

    maxQuantityAvailable = Math.floor(sortedLeadTimeArray.at(-1).max_qty) + inventoryOffset;
  }

  // Check if current input is within the maximum range
  if (inventoryQuantity >= quantityRequested) {
    availabilityStatus = 'stock';
  } else if (inventoryPolicy === 'continue' && isLeadTimeArrayValid(leadTimeArray) && useUp === false) {
    availabilityStatus = 'request';

    // eslint-disable-next-line camelcase
    sortedLeadTimeArray.some(({ max_qty, lead_time }) => {
      const adjustedMaxQty = Math.floor(max_qty) + inventoryOffset;

      if (availabilityStatus !== 'backorder' && adjustedMaxQty >= quantityRequested) {
        availabilityStatus = 'backorder';
        // eslint-disable-next-line camelcase
        leadTime = lead_time;

        return true;
      }

      previousBucketMaxQuantity = adjustedMaxQty;

      return false;
    });
  } else if (inventoryQuantity <= 0 && useUp === true) {
    availabilityStatus = 'unavailable';
  } else {
    availabilityStatus = 'request';
  }

  return {
    availabilityStatus,
    leadTime,
    maxQuantityAvailable: Math.max(0, maxQuantityAvailable),
    previousBucketMaxQuantity: Math.max(0, previousBucketMaxQuantity),
  };
}

export { isLeadTimeArrayValid, sortLeadTimeArray, calculateAvailabilityAndLeadTime };
